<template>
    <u-chip-flat-label v-bind="$attrs" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-chip-flat-label>
</template>

<script>
import UChipFlatLabel from "@/components/publish/styles/chips/u-chip-flat-label.vue";

export default {
    props: {},
    components: {
        UChipFlatLabel,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
